/* eslint-disable import/no-anonymous-default-export */
import { CLEAR_AUTH, SET_TOKEN } from "./actionTypes";

const initialState: any = {
  token: null,
  refreshToken: null,
};

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload.access_token,
        refreshToken: action.payload.refresh_token,
      };
    case CLEAR_AUTH:
      return {
        ...state,
        token: null,
        refreshToken: null,
      };
    default:
      return {
        ...state,
      };
  }
};
